import {Inject, Injectable} from '@angular/core';
import {DOCUMENT, Location} from '@angular/common';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  constructor(@Inject(DOCUMENT) private document: Document, private location: Location) {
  }

  // function to switch app style theme
  public switchTheme(theme: string): void {
    let themeLink = this.document.getElementById('app-theme') as HTMLLinkElement;

    if (themeLink) {
      themeLink.href = this.location.prepareExternalUrl(`assets/styles/themes/${environment.company}/${theme}.css`);
    }
  }

  // function to set app style palette
  public setPalette(palette: string): void {
    let paletteLink = this.document.getElementById('app-palette') as HTMLLinkElement;

    if (paletteLink) {
      paletteLink.href = this.location.prepareExternalUrl(`assets/styles/palettes/${environment.company}/${palette}.css`);
    }
  }
}
